import { render, staticRenderFns } from "./TableRecipient.vue?vue&type=template&id=6e3c3476&"
import script from "./TableRecipient.vue?vue&type=script&lang=js&"
export * from "./TableRecipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports